import Vue from 'vue';
import PerfectScrollbar from 'perfect-scrollbar';
import ListMap from './list/list-map';

export default function () {
  const map = document.querySelector('.map');

  if (map) {
    new Vue({
      el: map,
      delimiters: ['${', '}}'],
      data() {
        return {
          isShow: false,
          content: window.map,
          tabBtns: null,
          tabs: null,
          filterData: {},
          filterItems: [],
          mapWasShowed: false,
        };
      },
      components: {
        ListMap,
      },
      mounted() {
        if (this.$refs.pins) {
          if (this.$refs.pins.childElementCount > 4) {
            this.scrollbar = new PerfectScrollbar(this.$refs.pins, {
              wheelPropagation: false,
              suppressScrollX: true,
              wheelSpeed: 0.5,
            });
          }
        }
        const checkedItems = Array.from(this.$el.querySelectorAll('.map__checkbox-label--checked'));
        if (checkedItems) {
          checkedItems.forEach((item) => {
            const filtered = this.content.items.filter(elem => elem.iconId === item.dataset.icon);
            const [checkedItem] = filtered;
            this.filterItems.push(checkedItem);
          });
        }
        this.tabBtns = [].slice.call(this.$el.querySelectorAll('.map__tab-btn'));
        this.tabs = [].slice.call(this.$el.querySelectorAll('.map__tab'));
        this.customLabel = [].slice.call(this.$el.querySelectorAll('.map__checkbox .map__checkbox-label--checked'));

        if (this.tabBtns.length !== 0) {
          this.tabBtns.forEach((btn, index) => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();

              this.changeTabs(btn, index);
            });
          });
        }
        if (this.customLabel.length) {
          this.customLabel.forEach((cl) => {
            cl.checked = true;
          });
        }
      },
      methods: {
        getMore() {
          this.isShow = !this.isShow;
        },
        setValue(e) {
          e.target.classList[e.target.checked ? 'remove' : 'add']('map__checkbox-label--checked');
          e.target.checked = !e.target.checked;
          if (e.target.checked && e.target.dataset && e.target.dataset.icon) {
            this.content.items.forEach((elem) => {
              if (elem.iconId === e.target.dataset.icon) {
                if (this.filterItems.filter(item => item.iconId === elem.iconId).length === 0) {
                  this.filterItems.push(elem);
                }
              }
            });
          }
          if (!e.target.checked && e.target.dataset && e.target.dataset.icon) {
            const filtered = this.filterItems.filter(item => item.iconId !== e.target.dataset.icon);
            this.filterItems = filtered;
          }
        },
        changeTabs(btn, index) {
          this.tabBtns.forEach(tmp => tmp.classList.remove('map__tab-btn--active'));
          this.tabs.forEach(tmp => tmp.classList.remove('map__tab--active'));

          btn.classList.add('map__tab-btn--active');
          this.tabs[index].classList.add('map__tab--active');
        },
        updateMapView(e) {
          if (e.target.hasAttribute('data-map') && !this.mapWasShowed) {
            this.$refs.mapContainer.updateBounds();
            this.mapWasShowed = true;
          }
        },
      },
      computed: {
        mapItems() {
          return this.filterItems;
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/map/map.js